import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatPercentHundredths,
} from '@bingads-webui-campaign/recommendation-core';

export class SearchVolumeDeltaColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType, isOptimizationScoreOn }) {
    const title = i18n.getString('Details_View_Est_Search_Volume') || 'Weekly search volume change';

    super({
      name: 'searchVolumeDelta',
      property: 'Opportunities/WoWInDecimal',
      title,
      bodyClasses: ['grid-column-searchVolumeDelta', isOptimizationScoreOn ? 'with-optimization-score' : ''],
      colClasses: ['col-searchVolumeDelta'],
      sortable: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.RisingQueryKeywordOpportunitySummary/WoWInDecimal',
      helpId: 'Pop_BA_Recommendations_WeeklySearchVolChg',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({ value }) {
    const WoWInDecimalThreshold = 20;
    return value > WoWInDecimalThreshold ? `↑ >${formatPercentHundredths(WoWInDecimalThreshold, this.i18n)}`
      : `↑ ${formatPercentHundredths(value, this.i18n)}`;
  }

  get property() {
    return {
      get(item) {
        return _.chain(item.Opportunities).first().result('WoWInDecimal').value()
          || _.chain(item.Opportunities).first().result('WoW').value();
      },
      key: 'Opportunities/WoWInDecimal',
    };
  }
}
